var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"page-about-project"},[_c('SecBanner',{attrs:{"imgURL":_vm.imageURL}}),_c('SecPriceTime',{attrs:{"imgURL":_vm.imageURL}}),_c('SecAboutWeb',{attrs:{"imgURL":_vm.imageURL}}),_c('SecTerms'),(_vm.isIosApp)?_c('Footer'):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }